import React, { Fragment } from 'react';

import BlockContent from '@sanity/block-content-to-react';

import { Button } from 'react-bootstrap';
import { Link } from 'gatsby';

import { FiBox, FiGithub } from 'react-icons/fi';
import { FaRegMoneyBillAlt } from 'react-icons/fa';
import { GoCheck } from 'react-icons/go';

import imageUrlFor from 'helpers/image-url';

const IsFree = ({ price }) => {
  if (price.toLowerCase() === 'free') {
    return <GoCheck className="icon text-success" />;
  }
  return <FaRegMoneyBillAlt className="icon" />;
};

const ToolDetail = ({
  node: {
    name,
    description,
    logo,
    developer,
    price,
    _rawContent,
    url,
    githubUrl,
    categories,
    tags,
  },
}) => {
  return (
    <div className="tool-detail">
      <div className="header">
        {logo ? (
          <img src={imageUrlFor(logo.asset.url).width(80).url()} alt="" className="logo" />
        ) : (
          <FiBox className="logo" />
        )}
        <div className="content">
          <h1 className="title">{name}</h1>
          <p className="description">{description}</p>
          <div className="info">
            {developer && (
              <span className="item">
                {developer.logo && (
                  <img
                    src={imageUrlFor(developer.logo.asset.url).height(32).url()}
                    className="icon"
                    alt=""
                  />
                )}
                Built by
                <a className="link-inline" href={developer.url} rel="noreferrer" target="_blank">
                  {developer.name}
                </a>
              </span>
            )}
            {price && (
              <span className="price">
                <IsFree price={price} className="icon" />
                {price}
              </span>
            )}
          </div>
        </div>
        {tags && (
          <div className="tags">
            {tags.map(({ name: tagName, slug: { current: slug } }) => (
              <Link key={slug} to={`/tag/${slug}`} className="tag">
                {tagName}
              </Link>
            ))}
          </div>
        )}
      </div>
      <div className="content">
        {_rawContent && <BlockContent className="richtext" blocks={_rawContent} />}
      </div>
      <div className="sidebar">
        {url && (
          <Button variant="success" block as="a" target="_blank" href={url}>
            Website
          </Button>
        )}
        {githubUrl && (
          <Button variant="dark" color="white" block as="a" target="_blank" href={githubUrl}>
            <FiGithub className="icon" />
            GitHub
          </Button>
        )}
        {categories && (
          <Fragment>
            <br />
            <h5>Categories</h5>
          </Fragment>
        )}
        {categories?.map(({ name: categoryName, slug: { current: slug } }) => (
          <Link key={slug} to={`/category/${slug}`} className="link">
            {categoryName}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ToolDetail;
